module.exports = __webpack_public_path__ + "static/img/logo.bf43f42.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo.png
// module id = dLd/
// module chunks = 18